module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/044-latvia-8a7059bb32331e73bc58b20adfa35c81.svg";